var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2863_33678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.474 20.7628L23.7447 2.03356L21.9295 0.219727L1.38647 20.7628C0.714926 21.4362 0.714926 22.5262 1.38647 23.1983L14.2671 36.0785L21.9295 43.7428L42.474 23.1983C43.1459 22.5262 43.1459 21.4362 42.474 20.7628ZM21.9295 28.4142L15.4963 21.9814L21.9295 15.5464L28.3641 21.9814L21.9295 28.4142Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8523 15.4365C17.6406 11.2229 17.619 4.39852 21.8075 0.160156L7.72656 14.2357L15.3908 21.8999L21.8523 15.4365Z",
    fill: "url(#paint0_linear_2863_33678)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4466 22.0693L21.9941 28.5204C24.0276 30.5519 25.1712 33.3095 25.1712 36.1847C25.1712 39.0597 24.0276 41.8155 21.9941 43.8489L36.109 29.7336L28.4466 22.0693Z",
    fill: "url(#paint1_linear_2863_33678)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2863_33678",
    x1: 19.087,
    y1: 10.5453,
    x2: 11.7191,
    y2: 17.9114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2863_33678",
    x1: 24.839,
    y1: 33.3417,
    x2: 32.1923,
    y2: 25.9885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2863_33678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.5478885e7c57a46f502bbce61ac06d07.svg";
export { ForwardRef as ReactComponent };